import { smsActions, smsReducers } from '@frontegg/redux-store';
import { reducerActionsGenerator, stateHookGenerator } from './hooks';
const defaultMapper = state => state;
export function useSmsState(stateMapper = defaultMapper) {
  return stateHookGenerator(stateMapper, 'smsState');
}
export const useSmsActions = () => reducerActionsGenerator(smsActions, smsReducers);